import { Environment } from './environment.model';

/** `ng build --configuration=development` / branch develop — uses real dev API. */
export const environment: Environment = {
  production: false,
  baseUrl: 'https://homologacao.vivest.com.br',
  apiPerfilInvestimentoUrl: 'api-perfil-investimento-dev',
  apiGatewayPrefix: 'apis',
  // 5 = TipoCampanha.Suitability (COD_CAMPANHA) na API; o portal só resolve campanhas com esse código.
  defaultCodCampanha: 5,
  secretPortal: '79f52b2cc565ef16f07d7f8f52df4ecdd7fa1923995f16333fc4b2055476a146',
  subscriptionKeyPortalVivestCenter: '036b8f1ade46471e900bda16de0cbfd6',
  allowDevAuthBypass: false,
};
